/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import Calendar from 'react-calendar';
import moment from 'moment';
import classnames from 'classnames';
import { noop, head, castArray, map, assign } from 'lodash';

// local dependencies
import { Icon } from 'modules/icon-bank';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { calendar as Calendar } from 'modules/calendar';
 *
 * // render
 * <Calendar propName='propValue'/>
 */
export const calendar = ( props ) => {

    // create safe value (native date)
    const value = map( assign( [ moment( new Date() ).format( 'MM-DD-YYYY' ), moment( new Date() ).format( 'MM-DD-YYYY' ) ], castArray( props.value ) ), _date => {
        return moment( _date, 'MM-DD-YYYY' ).isValid() ? moment( _date, 'MM-DD-YYYY' ).toDate() : new Date();
    } );

    // selected date (state)
    const [ selectedDate, setSelectedDate ] = useState( value );

    // get arrow icons for the calendar
	const rightArrow = <Icon id='rightArrow'/>;
	const leftArrow = <Icon id='leftArrow'/>;
	const rightdoublearrow = <Icon id='rightDoubleArrow' />;
    const leftdoublearrow = <Icon id='leftDoubleArrow' />;

    // dynamic widget class names
    const widgetClassName = classnames( 'ui-calendar', props.className );
    const calendarClassName = classnames( 'ui-calendar__calendar', props.calendarClassName );
    
    return (
        <div className={ widgetClassName }>
            <Calendar
                className={ calendarClassName }
                nextLabel={  rightArrow }
                next2Label={ rightdoublearrow }
                prevLabel={ leftArrow }
                prev2Label={ leftdoublearrow }
                calendarType='US'
                selectRange = { props.selectRange }
                allowPartialRange = { props.allowPartialRange }
                minDate = { props.minDate ? moment( props.minDate, 'MM-DD-YYYY' ).toDate() : undefined }
                maxDate = { props.maxDate ? moment( props.maxDate, 'MM-DD-YYYY' ).toDate() : undefined }
                value={ props.selectRange ? selectedDate : head( selectedDate ) }
                onChange={ ( dateSelection ) => {

                    // update state
                    setSelectedDate( castArray( dateSelection ) );

                    // update callback
                    props.onChange( props.selectRange ? map( dateSelection, _date => moment( _date ).format( 'MM-DD-YYYY' ) ) : moment( head( castArray( dateSelection ) ) ).format( 'MM-DD-YYYY' ) ); // callback
                } }
            />
        </div>
    );
};

// set display name
calendar.displayName = 'calendar';

// set default props
calendar.defaultProps = {
    className: undefined,
    calendarClassName: undefined,
    value: moment( new Date() ).format( 'MM-DD-YYYY' ), // string or array of strings in `MM-DD-YY` format
    onChange: noop, // returns string or array of strings in `MM-DD-YY` format
    selectRange: false,
    allowPartialRange: false,
    minDate: undefined,
    restrictMaxDate: true,
    
    // maxDate: moment( new Date() ).format( 'MM-DD-YYYY' ),
    maxDate: undefined,
};

// prop types
calendar.propTypes = {};
